import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Dbattrs } from '../../../../../../../core/entities/dbattrs.model';
import { DbattrsService } from '../../../../../../../core/repositories/dbattrs.service';

@Injectable()
export class EditDialogsDbattrsService {

  dbattrs: Dbattrs = new Dbattrs();
  originalDbattrs: Dbattrs = new Dbattrs();
  parametersInput: Dbattrs = new Dbattrs();

  allDbattrs: Dbattrs[] = [];
  changetitulo: boolean = false;

  constructor(private dbattrsService: DbattrsService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.dbattrs = data.dbattr;
    this.changetitulo = data.titulochange;
    this.originalDbattrs = _.cloneDeep(this.dbattrs);
    console.log(data);
    return this.dbattrsService.findAll().pipe(map((result: Dbattrs[]) => {
      this.allDbattrs = result;
      if (Utils.noUndfAndNull(data.dbattr)) {
        this.dbattrs = _.cloneDeep(data.dbattr);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el dbattr
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.dbattrs.id, "")) {

      /*comparamos el dbattr original con el modificado*/
      let compareDbattr = this.compare(this.dbattrs, this.originalDbattrs);

      if(compareDbattr){
        return of(-1);
      }else{
        return this.dbattrsService.postDbattr(this.dbattrs);
      }

    }else{
      return this.dbattrsService.postDbattr(this.dbattrs);
    }
  }

  /**
  * @description
  * Comprueba si dos Dbattrs son iguales.
  * @param datoX Dbattr 1
  * @param datoY Dbattr 2
  * @returns True si son iguales
  */
  public compare(itemX:Dbattrs, itemY:Dbattrs):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
          || !Utils.compareTextOrNumber(itemX.description, itemY.description)
          || !Utils.compareTextOrNumber(itemX.adapterstr, itemY.adapterstr)
          || !Utils.compareTextOrNumber(itemX.usernamestr, itemY.usernamestr)
          || !Utils.compareTextOrNumber(itemX.passwordstr, itemY.passwordstr)
          || !Utils.compareTextOrNumber(itemX.dbattr1key, itemY.dbattr1key)
          || !Utils.compareTextOrNumber(itemX.dbattr1value, itemY.dbattr1value)
          || !Utils.compareTextOrNumber(itemX.dbattr2key, itemY.dbattr2key)
          || !Utils.compareTextOrNumber(itemX.dbattr2value, itemY.dbattr2value)
          || !Utils.compareTextOrNumber(itemX.dbattr3key, itemY.dbattr3key)
          || !Utils.compareTextOrNumber(itemX.dbattr3value, itemY.dbattr3value)
          || !Utils.compareTextOrNumber(itemX.dbattr4key, itemY.dbattr4key)
          || !Utils.compareTextOrNumber(itemX.dbattr4value, itemY.dbattr4value)
          || !Utils.compareTextOrNumber(itemX.dbattr5key, itemY.dbattr5key)
          || !Utils.compareTextOrNumber(itemX.dbattr5value, itemY.dbattr5value)
        ) && (itemX.code !== ""))
          return false;
      }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.dbattrs = new Dbattrs();
  }

}
